import React from 'react';
import PropTypes from 'prop-types';
import {
  AppstoreOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CommentOutlined,
  ExperimentOutlined,
  FileSearchOutlined,
  FundOutlined,
} from '@ant-design/icons';
import { Typography } from 'antd';
import { textOrDash } from './SimpleWorkspaceSupport';
import styles from './SimpleWorkspace.less';

const { Text } = Typography;

export const WORKSPACE_NAVIGATION_ITEMS = [
  { key: 'overview', label: '训练概览', icon: AppstoreOutlined },
  { key: 'action', label: '动作评估', icon: ExperimentOutlined },
  { key: 'action-profile', label: '动作画像', icon: BarChartOutlined },
  { key: 'course', label: '课程评估', icon: FileSearchOutlined },
  { key: 'communication', label: '沟通观察', icon: CommentOutlined },
  { key: 'capability', label: '运动能力', icon: FundOutlined },
  { key: 'archive', label: '档案时间线', icon: CalendarOutlined },
];

export const WORKSPACE_TAB_KEYS = new Set(
  WORKSPACE_NAVIGATION_ITEMS.map((item) => item.key),
);

export default function WorkspaceNavigation({
  activeKey,
  profile,
  memberDisplayName,
  memberId,
  onChange,
}) {
  const initial =
    memberDisplayName === '-' ? '会' : memberDisplayName.slice(0, 1);

  return (
    <aside className={styles.workspaceRail} aria-label="会员训练档案导航">
      <div className={styles.railMember}>
        <span className={styles.railAvatar}>{initial}</span>
        <span className={styles.railMemberCopy}>
          <Text ellipsis className={styles.railMemberName}>
            {memberDisplayName}
          </Text>
          <Text ellipsis className={styles.railMemberMeta}>
            ID {memberId}
          </Text>
        </span>
      </div>
      <nav className={styles.railNavigation}>
        {WORKSPACE_NAVIGATION_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = activeKey === item.key;
          return (
            <button
              key={item.key}
              type="button"
              className={`${styles.railNavigationItem} ${
                active ? styles.railNavigationItemActive : ''
              }`}
              aria-current={active ? 'page' : undefined}
              onClick={() => onChange(item.key)}
            >
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
      <div className={styles.railGoal}>
        <Text>当前目标</Text>
        <strong>{textOrDash(profile?.sportTarget)}</strong>
      </div>
    </aside>
  );
}

WorkspaceNavigation.propTypes = {
  activeKey: PropTypes.string.isRequired,
  profile: PropTypes.object,
  memberDisplayName: PropTypes.string.isRequired,
  memberId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  onChange: PropTypes.func.isRequired,
};

WorkspaceNavigation.defaultProps = {
  profile: null,
};
